var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('v-tabs',{staticClass:"sticky-bar",attrs:{"fixed-tabs":""},model:{value:(_vm.mobileTabs),callback:function ($$v) {_vm.mobileTabs=$$v},expression:"mobileTabs"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.label},[_vm._v("\n        "+_vm._s(_vm.isMobile ? _vm.$tc(`${tab.label}`) : '')+"\n    ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }